export default "__VITE_ASSET__Dh4El99G__"